module.exports = __webpack_public_path__ + "media/app/images/black-logo-text-ce10387f6f2896efe1b45fb79023e15c.png";